import { render, staticRenderFns } from "./FrontendServerless.vue?vue&type=template&id=ea42beea&"
import script from "./FrontendServerless.vue?vue&type=script&lang=js&"
export * from "./FrontendServerless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports